module.exports = __webpack_public_path__ + "static/media/page2.8546b1ea.png";